/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ApplicationContextClassLoaderParentUnnamedModuleClassLoader } from './application-context-class-loader-parent-unnamed-module-class-loader';
import { FilterRegistration } from './filter-registration';
import { JspConfigDescriptor } from './jsp-config-descriptor';
import { ServletRegistration } from './servlet-registration';
import { SessionCookieConfig } from './session-cookie-config';

/**
 * 
 * @export
 * @interface ServletContext
 */
export interface ServletContext {
    /**
     * 
     * @type {object}
     * @memberof ServletContext
     */
    'attributeNames'?: object;
    /**
     * 
     * @type {ApplicationContextClassLoaderParentUnnamedModuleClassLoader}
     * @memberof ServletContext
     */
    'classLoader'?: ApplicationContextClassLoaderParentUnnamedModuleClassLoader;
    /**
     * 
     * @type {string}
     * @memberof ServletContext
     */
    'contextPath'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof ServletContext
     */
    'defaultSessionTrackingModes'?: Set<ServletContextDefaultSessionTrackingModesEnum>;
    /**
     * 
     * @type {number}
     * @memberof ServletContext
     */
    'effectiveMajorVersion'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServletContext
     */
    'effectiveMinorVersion'?: number;
    /**
     * 
     * @type {Set<string>}
     * @memberof ServletContext
     */
    'effectiveSessionTrackingModes'?: Set<ServletContextEffectiveSessionTrackingModesEnum>;
    /**
     * 
     * @type {{ [key: string]: FilterRegistration; }}
     * @memberof ServletContext
     */
    'filterRegistrations'?: { [key: string]: FilterRegistration; };
    /**
     * 
     * @type {object}
     * @memberof ServletContext
     */
    'initParameterNames'?: object;
    /**
     * 
     * @type {JspConfigDescriptor}
     * @memberof ServletContext
     */
    'jspConfigDescriptor'?: JspConfigDescriptor;
    /**
     * 
     * @type {number}
     * @memberof ServletContext
     */
    'majorVersion'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServletContext
     */
    'minorVersion'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServletContext
     */
    'requestCharacterEncoding'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServletContext
     */
    'responseCharacterEncoding'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServletContext
     */
    'serverInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServletContext
     */
    'servletContextName'?: string;
    /**
     * 
     * @type {{ [key: string]: ServletRegistration; }}
     * @memberof ServletContext
     */
    'servletRegistrations'?: { [key: string]: ServletRegistration; };
    /**
     * 
     * @type {SessionCookieConfig}
     * @memberof ServletContext
     */
    'sessionCookieConfig'?: SessionCookieConfig;
    /**
     * 
     * @type {number}
     * @memberof ServletContext
     */
    'sessionTimeout'?: number;
    /**
     * 
     * @type {Set<string>}
     * @memberof ServletContext
     */
    'sessionTrackingModes'?: Set<ServletContextSessionTrackingModesEnum>;
    /**
     * 
     * @type {string}
     * @memberof ServletContext
     */
    'virtualServerName'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ServletContextDefaultSessionTrackingModesEnum {
    Cookie = 'COOKIE',
    Url = 'URL',
    Ssl = 'SSL'
}
/**
    * @export
    * @enum {string}
    */
export enum ServletContextEffectiveSessionTrackingModesEnum {
    Cookie = 'COOKIE',
    Url = 'URL',
    Ssl = 'SSL'
}
/**
    * @export
    * @enum {string}
    */
export enum ServletContextSessionTrackingModesEnum {
    Cookie = 'COOKIE',
    Url = 'URL',
    Ssl = 'SSL'
}


